/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ICommerceWebModuleData } from './commerce-web-module.data';
import { ICommerceWebModuleProps } from './commerce-web-module.props.autogenerated';
import App from './App';
import { SessionExpiredPage } from './pages/session-expired-page';

export interface ICommerceWebModuleViewProps extends ICommerceWebModuleProps<ICommerceWebModuleData> {}

/**
 *
 * CommerceWebModule component
 * @extends {React.PureComponent<ICommerceWebModuleProps<ICommerceWebModuleData>>}
 */
class CommerceWebModule extends React.PureComponent<ICommerceWebModuleProps<ICommerceWebModuleData>> {
    public render(): JSX.Element | null {
        return <App sessionExpired={this._renderSessionExpired} />;
    }

    private readonly _renderSessionExpired = (reason: string): JSX.Element => (
        <SessionExpiredPage
            context={this.props.context}
            telemetry={this.props.telemetry}
            title={this.props.resources.sessionExpiredTitle}
            message={this.props.resources.sessionExpiredText}
            reason={reason}
        />
    );
}

export default CommerceWebModule;
